import React from 'react';

import { Box, Inline, xcss } from '@atlaskit/primitives';
import { EmojiPlaceholder } from '@atlaskit/emoji';

const wrapperStyles = xcss({
	paddingLeft: 'space.100',
	paddingRight: 'space.150',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	marginTop: '-1px' as any,
});

const countSkeletonStyles = xcss({
	width: '10px',
	height: '10px',
	borderRadius: 'border.radius.circle',
	backgroundColor: 'color.background.neutral.subtle.pressed',
});

export const ReactionsSummaryViewPlaceholder = () => {
	return (
		<Inline space="space.050" alignBlock="center" xcss={wrapperStyles}>
			<EmojiPlaceholder shortName="loading-placeholder" size={16} />
			<EmojiPlaceholder shortName="loading-placeholder" size={16} />
			<EmojiPlaceholder shortName="loading-placeholder" size={16} />
			<Box xcss={countSkeletonStyles} />
		</Inline>
	);
};
